import React, { Component } from "react";
import MembersFormRow from "./MembersFormRow";

class MembersForm extends Component {
  constructor(props) {
    super(props);
    this.state = { pushtokens: [{ timestamp: 0, pushtoken: "Not a token" }] };
  }
  componentDidMount() {
    this.makeRemoteRequest();
  }
  makeRemoteRequest = () => {
    fetch("/pushtokens")
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        if (data !== undefined && data.timestamp !== "0") {
          this.setState({
            pushtokens: data.pushtokens
          });
        }
      });
  };
  handleCallbackUpdate = data => {
    console.log(
      "Calling handleCallbackUpdate for " +
        data.token +
        " with state " +
        data.state
    );

    fetch("/updateMember", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        pushtoken: data.token,
        state: data.state
      })
    });

    let updatedState = JSON.parse(JSON.stringify(this.state));
    updatedState.pushtokens.map(item => {
      if (item.token === data.token) {
        console.log("UPDATING STATE");
        item.state = data.state;
      }
      return data.state;
    });
    this.setState(updatedState);
  };

  handleCallbackVortexUpdate = data => {
    console.log(
      "Calling handleCallbacVortexkUpdate for " +
        data.token +
        " with state " +
        data.state
    );

    fetch("/updateMemberVortex", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        pushtoken: data.token,
        isVortex: data.state
      })
    });

    let updatedState = JSON.parse(JSON.stringify(this.state));
    updatedState.pushtokens.map(item => {
      if (item.token === data.token) {
        console.log("UPDATING Vortex STATE");
        item.isVortex = data.state;
      }
      return data.state;
    });
    this.setState(updatedState);
  };
  handleCallbackUpdateComment = data => {
    console.log(
      "Calling handleCallbackUpdateComment for " +
        data.token +
        " with state " +
        data.state
    );
  }

  render() {
    if (typeof this.state.pushtokens !== "undefined") {
      return (
        <div>
          <form>
            <table className="table table-striped table-sm">
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>Grant Access</th>
                  <th>XC-GAA</th>
                  <th>Install Date</th>
                  <th>Messaging</th>
                  <th>Pushtoken</th>
                  <th>Name</th>
                  <th>Comment</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {this.state.pushtokens.map((pushtoken,index) => (
                  <MembersFormRow
                    key={pushtoken.token+"-"+index}
                    pushtoken={pushtoken}
                    index={index}
                    callbackUpdate={this.handleCallbackUpdate}
                    callbackVortexUpdate={this.handleCallbackVortexUpdate}
                    callbackOnChange={this.handleCallbackChange}
                    callbackUpdateTable={this.makeRemoteRequest}
                    callbackUpdateComment={this.handleCallbackUpdateComment}
                  />
                ))}
              </tbody>
            </table>
          </form>
        </div>
      );
    } else return null;
  }
}

export default MembersForm;
